import { useEffect } from 'react';
import Alert from 'react-bootstrap/Alert';

const UserPermissionAlert = ({
  initialConstraintsState, missingUserPermission, organizationDisplayName, result, setCurrentStepResult, setInitialConstraintsState,
}) => {
  useEffect(() => {
    if (!initialConstraintsState && missingUserPermission) {
      setInitialConstraintsState(true);
      setCurrentStepResult({
        roles: {},
        constraints: { ...result.constraints, permissionError: missingUserPermission },
      });
    }
  }, [initialConstraintsState, missingUserPermission, result, setCurrentStepResult, setInitialConstraintsState]);

  if (!missingUserPermission) return null;

  return (
    <Alert className="content-alert" variant="warning">
      <p className="mt-2"><strong>Notice - Permissions Warning</strong></p>
      <p>
        You do not have permission to modify the IAM policy on
        {' '}
        <strong>{ organizationDisplayName }</strong>
        {' '}
        organization.
        We are unable to grant Rackspace these recommended roles.
      </p>
      <p>
        This is not a critical error but it may impact our ability to service your account.
        If you have concerns, please work with your Administrator to ensure you have sufficient
        permissions on your Organization (e.g. Organization Admin).
      </p>
    </Alert>
  );
};

export default UserPermissionAlert;
